import React from 'react';
import { login } from '../services/auth';
import './Login.css';

const Login: React.FC = () => {
  const handleLogin = () => {
    login();
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Tenant Management</h1>
        <p>Sign in to manage tenants, solutions, and units</p>
        <button onClick={handleLogin} className="login-button">
          Sign In with Cognito
        </button>
      </div>
    </div>
  );
};

export default Login;

